import { PanoramaImage } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreatePanoramaImageArgs,
    getDefaultPanoramaImageCreateArgs,
    UpdatePanoramaImageArgs,
} from "@nova/serializer/src/client/validators/images/panorama"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { maybeSetProjectLocation } from "../projectLocation"

const {
    create: createPanoramaImage,
    update: updatePanoramaImage,
    delete: deletePanoramaImage,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    PanoramaImage, // entity type
    CreatePanoramaImageArgs, // create args to send to server
    [
        "longitude",
        "latitude",
        "altitude",
        "pitch",
        "yaw",
        "roll",
        "takenAt",
        "flightPitch",
        "flightYaw",
        "flightRoll",
    ], // create args required by action
    UpdatePanoramaImageArgs, // update args
    { flightId: string; name: string } // context
>("PanoramaImage")

export const addPanoramaImagesToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            const optimisticData = {
                ...data,
                id: context.name,
                ...getDefaultPanoramaImageCreateArgs(),
            }
            createPanoramaImage(socket, { ...data, id: optimisticData.id }, context)
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["panoramaFlights", { id: context.flightId }, "images"],
                })
            )
            const project = store.getState().project.data
            const hasLocation =
                optimisticData.latitude !== undefined && optimisticData.longitude !== undefined
            maybeSetProjectLocation(
                store,
                project.orgId,
                project.id,
                hasLocation
                    ? { latitude: optimisticData.latitude!, longitude: optimisticData.longitude! }
                    : null
            )
        })
        .addCase(updateAction, (store, { payload: { id, updates, context } }, socket) => {
            updatePanoramaImage(socket, id, updates, context)
            store.dispatch(
                updateEntitySocket({
                    updates,
                    path: ["panoramaFlights", { id: context.flightId }, "images", { id }],
                })
            )
        })
        .addCase(deleteAction, (store, { payload: { id, context } }, socket) => {
            deletePanoramaImage(socket, id, context)
            store.dispatch(
                deleteEntitySocket({
                    path: ["panoramaFlights", { id: context.flightId }, "images", { id }],
                })
            )
        })

export {
    createAction as createPanoramaImage,
    updateAction as updatePanoramaImage,
    deleteAction as deletePanoramaImage,
}
